import { useState, useEffect,useContext } from 'react';
import axios from 'axios';
import { useNavigate,Link } from 'react-router-dom';
import daypass from '../../../../assets/images/daypass.gif';
import annualpass from '../../../../assets/images/annualpass.jpg'
import './Cart.css'; 
import { PassContext } from '../../../../hooks/PassContext.js';
import { CartUpdateService } from '../../../../services/CartUpdateService.js'; // Import the CartUpdateService
import { CART_BASE_URL } from '../../../../config/ApiConfig.js';
import { showNotification } from '../../../../services/NotificationService.js';

export const Cart = () => {
    const  { types } = useContext(PassContext);
    const [ordersData, setOrdersData] = useState([]);
    const [cartDataItems,setCartDataItems] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();
    const cartGUID= sessionStorage.getItem('wa_crt_cid');

    useEffect(() => {
        // Guard against unnecessary API calls
        if (cartGUID && types && types.length > 0) {
            fetchCartDetails();
        } else if (!cartGUID) {
            loadOrdersFromSession();
        }
    }, [cartGUID, types]);

    const loadOrdersFromSession = () => {
        const storedOrders = JSON.parse(sessionStorage.getItem('wa_crt_itms')) || [];
        setOrdersData(storedOrders);
    };

    const fetchCartDetailsAPI = async (cartGUID) => {
        setErrorMessage('')
        try {
            const response = await axios.get(`${CART_BASE_URL}/GetCartDetailsByGUID/${cartGUID}`);
            return response.data.data.cartDetails.passes;
        } catch (error) {
            console.error("Error fetching cart details:", error);
            setErrorMessage('We encountered an issue while fetching Cart Details. Please refresh the page or try again later')
        }
    };

    const fetchCartDetails = async()=>{
        try{
            const orderDetails = await fetchCartDetailsAPI(cartGUID);
            setCartDataItems(orderDetails); //Store Each pass item in an array
            // Flattened array to collect each orderDetail mapped with its corresponding type information
            const mergedOrdersData = types.flatMap(type => {
                // Find all matching orders for this passID
                const matchingOrders = orderDetails.filter(order => order.passID === type.passID);
                return matchingOrders.map(order => ({
                    ...type,                   
                    quantity: order.quantity,  
                    passDate: order.passDate,  
                })); 
            });

            setOrdersData(mergedOrdersData);
            sessionStorage.removeItem("wa_crt_itms");
        }catch(error){
            console.error("Error fetching cart details:", error);
        }
    }

    //Calculate total cost of all orders
    const calculateTotalCost = () => {
        const total = ordersData.reduce((total, order) => {
            return total + (order.price + order.processingFee) * order.quantity;
        }, 0);
        return total;
    };
    
    const totalProcessingFee = ()=>{
        return ordersData.reduce((total,order)=> total+ (order.processingFee*order.quantity),0);
    }

    const handleRemove = async(index) => {
        try{
            if(cartGUID){
                const orderDetails = cartDataItems;
                const { passID, passDate } = ordersData[index];
                // Find the matching cartItemID in orderDetails based on passID and passDate
                const matchedDetail = orderDetails.find(detail => 
                    detail.passID === passID && detail.passDate === passDate
                );
    
                if (!matchedDetail || !matchedDetail.cartItemID) {
                    console.error("cartItemID not found for the item.");
                    return;
                }
    
                const { cartItemID } = matchedDetail;
                const cartItemId=cartItemID;
                const deleteItem=await axios.delete(`${CART_BASE_URL}/DeleteCartItem?cartItemId=${cartItemId}`);
                if(deleteItem.data.statusId===200){
                    showNotification(deleteItem.data.message,"success");
                    try{
                        const orderDetails = await fetchCartDetailsAPI(cartGUID);
                        setCartDataItems(orderDetails);
                    }catch(error){
                        console.error(error);
                    }

                }
                // Update local state after successful deletion on the server
                const updatedOrders = ordersData.filter((_, i) => i !== index);
                setOrdersData(updatedOrders);
    
                // For Header I need to do this -Trigger the update event so other components can listen
                CartUpdateService.updateCart(updatedOrders);
                //----------This above line is useful for header only, no use in Orders Component
    
            }else{
                const updatedOrders = ordersData.filter((_, i) => i !== index);
                setOrdersData(updatedOrders);
                showNotification("Cart item deleted successfully.","success");
                sessionStorage.setItem('wa_crt_itms', JSON.stringify(updatedOrders));
            }
        }catch(error){
            console.error("Error removing item from cart:", error);
            showNotification("Unable to delete pass at the moment.Please try again later!","error");
        }
    };

    const updateQuantity = async(index, newQuantity) => {
        if (newQuantity < 1) return; 
        const updatedOrders = [...ordersData];
        const { passID, passDate } = updatedOrders[index];
        // Store previous value so that we can restore it case if the api for update is failed due to some reason
        const previousQuantity = updatedOrders[index].quantity; 
        const previousTotalPrice = updatedOrders[index].totalPrice;
        updatedOrders[index].quantity = newQuantity; 
        updatedOrders[index].totalPrice = newQuantity * (updatedOrders[index].price+updatedOrders[index].processingFee);    
        setOrdersData(updatedOrders);
        if(cartGUID){
            try {
                // Fetch existing cart items for this cartGUID
                const orderDetails = cartDataItems;
                 // Find the matching detail based on passID and passDate
                const matchedDetail = orderDetails.find(detail => 
                    detail.passID === passID && detail.passDate === passDate
                );
                const { cartItemID } = matchedDetail;
                const cartItemId=cartItemID;
                const updatedItem=await axios.put(`${CART_BASE_URL}/UpdateQuantity?cartItemId=${cartItemId}&newQuantity=${newQuantity}`);
                if(updatedItem.data.statusId===200){
                    showNotification(updatedItem.data.message,"success");
                    try{
                        const orderDetails = await fetchCartDetailsAPI(cartGUID);
                        setCartDataItems(orderDetails);
                    }catch(error){
                        console.error(error);
                    }
                }
                // For Header I need to do this -Trigger the update event so other components can listen
                CartUpdateService.updateCart(updatedOrders);
                //----------This above line is useful for header only, no use in Orders Component
            }catch(error){
                console.log(error);
                // Revert Quantity And Price to previous data if the api's fail
                updatedOrders[index].quantity = previousQuantity;
                updatedOrders[index].totalPrice = previousTotalPrice;
                setOrdersData(updatedOrders);
                showNotification("Unable to update the quantity of an item at the moment.Please try again later","error");
            }
        }else{
            showNotification("Cart item quantity updated successfully.","success")
            sessionStorage.setItem('wa_crt_itms', JSON.stringify(updatedOrders));
        }
    };

    const formatAnnualPassDate = (date) => {
        const startDate = new Date(date);
        if (isNaN(startDate)) return 'Invalid Date'; // Return 'Invalid Date' if parsing fails
        const startMonth = startDate.toLocaleString('en-US', { month: 'long' });
        const startYear = startDate.getFullYear();
        const endYear = startYear + 1;
        return `${startMonth} ${startYear} - ${startMonth} ${endYear}`;
    };

    const formatOneDayPassDate = (date) => {
        const oneDayDate = new Date(date);
        if (isNaN(oneDayDate)) return 'Invalid Date';
        return oneDayDate.toLocaleDateString('en-US', {
            weekday: 'long',
            month: 'long',
            day: 'numeric',
            year: 'numeric'
        });
    };
    
    const handleCheckout = async (event) => {
        event.preventDefault();
        if (ordersData.length === 0) {
            alert('Your cart is empty! Please add items before checkout.');
            return;
        }
        // Check if order has already been created
        if (cartGUID) {  
            try {
                const existingOrderDetails = cartDataItems;
                const cartID= cartDataItems[0].cartID;
                const cartId=cartID;
                
                // Compare `ordersData` and `existingOrderDetails` to detect changes
                const hasChanges = ordersData.some((order, index) => {
                    const existingOrder = existingOrderDetails.find(o => 
                        o.passID === order.passID && o.passDate === order.passDate
                    );
                    return (
                        !existingOrder ||
                        existingOrder.quantity !== order.quantity
                    );
                });
    
                if (!hasChanges) {
                    navigate('/delivery', { state: { cartId,cartGUID, passes: ordersData } });
                    return;
                }
                
            } catch (error) {
                console.error('Error fetching existing cart details:', error);
                return;
            }
        }
        // If cart is new or has changes, proceed with API call
        const cartData = ordersData.map(order => ({
            passID: order.passID,         
            quantity: order.quantity,
            passDate: order.passDate,
        }));
        const payload = {
            ...(cartGUID && { cartGUID: cartGUID }), // Include cartGUID only if it exists
            passes: cartData
        };
        
        try {
            const response = await axios.post(
                `${CART_BASE_URL}/SaveUpdateCart`, 
                payload,
                { headers: { "Content-Type": "application/json" } }
            );
    
            if (response.status === 201) {
                const newCartId = response.data.data.cartID;
                const cartGUID = response.data.data.cartGUID;
                sessionStorage.setItem('wa_crt_cid',cartGUID);
                const passes = response.data.data.passes;
    
                navigate('/delivery', { state: { cartId: newCartId,cartGUID:cartGUID, passes } });
            } else {
                console.log('Failed to place the order. Please try again.');
            }
        } catch (error) {
            console.error('Error during checkout:', error);
            showNotification(error.message,"error");
        }
    };

    return (
        <div className='cartOrders my-5'>
            <div className="order-container mx-auto w-100">
                <h2>Your Order</h2>
                {
                    errorMessage?<><h3 className='errorHandled'>{errorMessage}</h3></>:<>
                        {ordersData.length === 0 ? (<>
                            <p>Your shopping cart is currently empty.</p>
                            <hr></hr>
                            <p><button className='continue' onClick={() => navigate('/')}>Continue Shopping</button></p>
                        </>
                        ) : (
                        <>
                            <table className='mycart w-100'>
                                <tbody>
                                {ordersData.map((order, index) => (
                                    <tr key={index}>
                                        <td className="cart-image"> 
                                            <img src={order.longName.includes('Annual')?annualpass:daypass} alt={order.longName}/>
                                        </td>
                                        <td className="cart-product">
                                            {order.longName}
                                            <div className="cart-date-md">
                                                {order.longName.includes('Annual')
                                                    ? formatAnnualPassDate(order.passDate)
                                                    : formatOneDayPassDate(order.passDate)
                                                }
                                            </div>
                                            <button className="cart-remove "
                                                onClick={() => handleRemove(index)}
                                                style={{ background: 'none', border: 'none', color: 'gray', cursor: 'pointer', textDecoration: 'underline' }} 
                                            >Remove</button>
                                        </td>
                                        <td className="cart-date">
                                            {order.longName.includes('Annual')
                                                    ? formatAnnualPassDate(order.passDate)
                                                    : formatOneDayPassDate(order.passDate)
                                            }
                                        </td>
                                        <td className='cart-quantity'>
                                            <div className="quantityBox">
                                                <label className="label-small">Quantity</label>
                                                <div className="quantity d-flex">
                                                    <button 
                                                        type="button" 
                                                        className="quantity-change" 
                                                        onClick={() => updateQuantity(index, order.quantity - 1)}
                                                    >
                                                        –
                                                    </button>
                                                    <div className="quantity-amount" id="qtyDiv">{order.quantity}</div>
                                                    <button 
                                                        type="button" 
                                                        className="quantity-change" 
                                                        onClick={() => updateQuantity(index, order.quantity + 1)}
                                                    >
                                                        +
                                                    </button>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="cart-each">X: ${(order.price + order.processingFee).toFixed(2)}
                                        </td>
                                        <td className="cart-item-total">
                                            <span className="cart-item-total-label label-small">Subtotal</span>
                                            ${((order.price+order.processingFee)*order.quantity).toFixed(2)}
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                            <div className="cart-footer d-flex justify-content-between align-items-end">
                                <Link to='/' className='continue-shopping-button'>Continue Shopping</Link>
                                <div className='cart-total'>
                                    <h5 className='m-0'>Order Total: ${calculateTotalCost().toFixed(2)}</h5>
                                    <div className="cart-total-shipping">
                                        Total processing fee of ${totalProcessingFee().toFixed(2)} included
                                    </div>
                                    <button 
                                        className="checkout-button" 
                                        onClick={handleCheckout}
                                    >
                                        Proceed to Checkout
                                    </button>
                                </div>
                            </div>
                        </>
                    )}
                    </>
                }
            </div>
        </div>
    );
};